import { ConveyorBeltTheme, styles, variants } from '../ConveyorBeltStyles.css';
import { multiVariantStyles } from './ConveyorBeltVariants.css';
import { baseTheme } from './ConveyorBeltBaseTheme.css';

const ConveyorBeltStableTheme: ConveyorBeltTheme = {
  multiVariantStyles,
  baseTheme,
  variants,
  styles
};

export { ConveyorBeltStableTheme };
